<template>
  <!-- 收货 -->
  <div class="addPerson__wrap" v-show="visible">
    <el-header class="shadow page-header__wrap">
      <div class="flex">
        <div class="backBtn" @click="handleReturn">
          <el-image
            class="back-img"
            :src="require('@/assets/img/back.png')"
          ></el-image>
          <span>返回</span>
        </div>
        <div class="title">
          <span class="site">当前位置：</span>
          {{ $route.meta.title }}
          <span> > </span>
          详情
        </div>
      </div>
    </el-header>

    <div class="main">
      <div class="mainBox">
        <div class="itemTime">基础信息</div>
        <el-descriptions title="" :column="4">
          <el-descriptions-item label="订单日期">{{
            info.date
          }}</el-descriptions-item>
          <el-descriptions-item label="订单笔数">{{
            info.order_count
          }}</el-descriptions-item>
          <el-descriptions-item label="销售金额"
            >{{ info.order_amount }}元</el-descriptions-item
          >
        </el-descriptions>
        <el-descriptions title="" :column="4">
          <el-descriptions-item label="采购金额"
            >{{ info.purchase_amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="毛利">
            <span
              :class="
                (
                  Number(info.order_amount) - Number(info.purchase_amount)
                ).toFixed(2) < 0
                  ? 'redColor'
                  : ''
              "
              >{{
                (
                  Number(info.order_amount) - Number(info.purchase_amount)
                ).toFixed(2)
              }}</span
            >
            元</el-descriptions-item
          >
        </el-descriptions>
        <el-input
          style="width: 240px; margin-bottom: 10px"
          v-model.trim="table.params.order_no"
          placeholder="请输入订单号"
          clearable
          size="small"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getTable"
          ></el-button>
        </el-input>

        <el-table
          :data="tableData"
          style="width: 100%"
          border
          :row-class-name="tableRowClassNameFun"
        >
          <el-table-column type="index" label="ID" fixed></el-table-column>
          <el-table-column prop="order_no" label="订单编号">
            <template v-slot="{ row }">
              <el-button type="text" @click="showDetail(row.id)">{{ row.order_no }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="store_name" label="食堂名称">
          </el-table-column>
          <el-table-column prop="total_quantity" label="下单数量">
          </el-table-column>
          <el-table-column prop="amount" label="销售金额(元)">
          </el-table-column>
          <el-table-column prop="sorter_num" label="分拣数量">
          </el-table-column>
          <el-table-column prop="delivery_money" label="采购金额(元)">
          </el-table-column>
          <el-table-column prop="profit" label="毛利/元">
            <template slot-scope="{ row }">
              <span :class="row.profit < 0 ? 'redColor' : ''">{{
                row.profit
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="profit_rate" label="毛利率">
            <template slot-scope="{ row }">
              <span>{{ row.profit_rate }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间">
          </el-table-column>
        </el-table>
        <div class="pageWrap" v-if="table.total > 10">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="table.params.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="table.params.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="table.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 查看详情 -->
    <detail :numNeedRed="true" ref="detail" @refresh="getTable"></detail>
  </div>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import Detail from "@/layout/OrderDetail.vue";
export default {
  name: "FinanceOrderDetail",
  mixins: [mixinTable],
  components: { Detail },
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      info: {},
      tableData: [],
      table: {
        params: {
          order_no: "",
          address_id: "",
          merchant_id: "",
          page: 1,
          count: 10,
        },
        total: 0,
      },
      loading: false,
      currRow: {},
    };
  },
  methods: {
    getDetail(row) {
      this.currRow = row;
      this.getTable();
    },
    getTable() {
      let _params = {
        date: this.currRow.date,
        order_no: this.table.params.order_no,
        address_id: this.currRow.address_id,
        merchant_id: this.currRow.merchant_id,
        page: this.table.params.page,
        count: this.table.params.count,
      };
      this.$http.get("/admin/stat/info", { params: _params }).then((res) => {
        if (res.code === 1) {
          this.table.loading = false;
          this.info = res.data.info;
          this.tableData = res.data.list;
          this.table.total = res.data.total;
        }
      });
    },
    reset(done) {
      this.table.params.page = 1;
      this.table.params.count = 10;
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    showDetail(orderId) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(orderId);
      dom = null;
    },
    // 返回
    handleReturn() {
      this.$emit("refresh");
      this.toggle(false);
      this.tableData = [];
    },
    tableRowClassNameFun({ row, rowIndex }) {
      if (row.profit_rate <= 18) {
        return "warning-row";
      }
      {
        return "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}
.addPerson__wrap .main {
  overflow-x: hidden;
  background: #fff;
}
.returnBtn {
  z-index: 99;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
}
.pageWrap {
  text-align: center;
}
::v-deep .el-table .warning-row {
  color: #f56c6c;
}
::v-deep .el-table .success-row {
  color: #2cb167;
}
</style>
